/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'

export const CustomTooltip = ({ active, payload, label }: any) => {
  if (active && payload && payload.length) {
    const date = new Date(label)
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0') // getMonth() returns 0-11
    const year = date.getFullYear()
    const formattedDate = `${day}/${month}/${year}`

    return (
      <div
        style={{
          backgroundColor: '#fff',
          padding: '10px',
          border: '1px solid #ccc',
          borderRadius: '4px',
        }}
      >
        <p style={{ fontWeight: '600' }}>{`Date: ${formattedDate}`}</p>
        {payload.map((item: any, index: any) => {
          let displayName = item.name

          switch (item.name) {
            case 'dtM8':
              displayName = 'Total DTM 8'
              break
            case 'dtM7':
              displayName = 'Total DTM 7'
              break
            case 'expiredDTM8':
              displayName = 'Expired DTM 8'
              break
            case 'expiredDTM7':
              displayName = 'Expired DTM 7'
              break
            case 'demoDTM8':
              displayName = 'Demo DTM 8'
              break
            case 'demoDTM7':
              displayName = 'Demo DTM 7'
              break
            case 'alltechDTM8':
              displayName = 'Keenan DTM 8'
              break
            case 'alltechDTM7':
              displayName = 'Keenan DTM 7'
              break
            case 'icdtM8':
              displayName = 'IC DTM 8'
              break
            case 'icdtM7':
              displayName = 'IC DTM 7'
              break
            case 'advProDTM8':
              displayName = 'PRO/ADV DTM8 '
              break
            case 'proDTM7':
              displayName = 'PRO DTM 7'
              break
            case 'advDTM7':
              displayName = 'ADV DTM 7'
              break
            default:
              break
          }

          return (
            <p key={index} style={{ color: item.color }}>
              {`${displayName}: ${item.value.toFixed(2)}`}
            </p>
          )
        })}
      </div>
    )
  }

  return null
}
